// extracted by mini-css-extract-plugin
export default {"contentContainer":"About_contentContainer__XtsSD","container":"About_container__w0U1h","section1":"About_section1__DNoAD","section2":"About_section2__liAZ7"};